import {Layout, Button} from 'antd';
import React, {useState} from 'react';

import './sidebar.scss';
import {LeftOutlined, RightOutlined} from "@ant-design/icons";

const {Sider} = Layout;

export const Sidebar = props => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <Sider
      collapsible={!!props.collapsible}
      onCollapse={collapsed => setIsCollapsed(collapsed)}
      width={330}
      style={{height: '100%'}}
      className="inbox-sider"
      collapsedWidth={18}
      theme="light"
      reverseArrow={true}
      trigger={<Button shape="circle" icon={isCollapsed ? <LeftOutlined/> : <RightOutlined/>} />}
    >
      {props.children}
    </Sider>
  );
};
